export default {
  methods: {
    status(status) {
      if (status === 'IN') {
        return {
          nome: 'Em avaliação',
          color: 'info',
        };
      }
      if (status === 'EV') {
        return {
          nome: 'Publicado',
          color: 'success',
        };
      }
      // EX
      return {
        nome: 'Recusado',
        color: 'danger',
      };
    },
  },
};
